import { useForm } from "react-hook-form";
import { useState } from "react";
import { Step, StepLabel, Stepper } from "@mui/material";
import { T } from "../util/t";
import { FieldComponents } from "./FormKit";

export const useWizardFormKit = ({ steps, initialStep = 0, initialValues, onSubmit, onBack }) => {
    const { handleSubmit, control, trigger, getValues, setValue, resetField } = useForm({
        mode: "onChange",
        defaultValues: initialValues,
    });

    const [activeStep, setActiveStep] = useState(initialStep);

    const goForward = () => {
        window.scrollTo(0, 0);
        setActiveStep(activeStep + 1);
    };
    const goBack = () => {
        window.scrollTo(0, 0);
        setActiveStep(activeStep - 1);
    };

    const currentStep = steps[activeStep];
    const onGoBack = activeStep > initialStep ? goBack : onBack;
    const formSubmit = currentStep.submit ? onSubmit : goForward;

    const WizardStepper = () =>
        <Stepper activeStep={activeStep}>
            {steps.map(step => <Step key={step.name}><StepLabel><T>{step.name}</T></StepLabel></Step>)}
        </Stepper>;

    const step = currentStep.component ?
        <currentStep.component step={currentStep} control={control} getValues={getValues} setValue={setValue} resetField={resetField} trigger={trigger}/> :
        currentStep.fields && <FieldComponents fields={currentStep.fields} control={control} getValues={getValues} setValue={setValue}/>;

    return {
        control,
        handleSubmit: handleSubmit(formSubmit),
        buttonLabel: currentStep.buttonLabel,
        Stepper: WizardStepper,
        step,
        goBack: onGoBack
    };
};
